import { NavLink } from "react-router";

export type SubNavItem = { key: string; to: string; label: string; end?: boolean };

/** Sub-navigation within a module: one link per screen, driven by the route rather than by component state.
 *
 * Links, not buttons. A tab strip built from buttons cannot be bookmarked, sent to a colleague, reached with the
 * back button or named by a breadcrumb — which is what every People view was until this replaced it. For the same
 * reason the markup is a `<nav>` with `aria-current`, not a `role="tablist"`: these are navigations to other
 * addresses, and calling them tabs tells a screen reader the wrong thing about what happens on activation. */
export function SubNav({ items, label }: { items: SubNavItem[]; label: string }) {
  return (
    <nav aria-label={label} data-subnav className="mt-4 flex gap-1 overflow-x-auto border-b border-brand-grey-light">
      {items.map((i) => (
        <NavLink key={i.key} to={i.to} end={i.end} data-subnav-item={i.key}
          className={({ isActive }) =>
            `-mb-px shrink-0 border-b-2 px-4 py-2 text-sm font-semibold transition ${
              isActive ? "border-brand-primary text-brand-primary" : "border-transparent text-brand-grey hover:text-brand-charcoal"
            }`}>
          {i.label}
        </NavLink>
      ))}
    </nav>
  );
}
